import { useCallback } from "react";

import { Button } from "@/components/ui/button/button";

import { useDownloadCSV } from "./hooks";

import type { ViewData } from "../../../model/type";

type Props = {
	viewData: ViewData;
};

export const AboutForSearchResultTable = ({
	viewData: {
		searchResultTableData: { searchResultCountText, totalSalesAmountText, rows },
	},
}: Props) => {
	const { downloadECReceiptCSV } = useDownloadCSV();

	const handleClickDownloadCSVButton = useCallback(() => {
		downloadECReceiptCSV(rows);
	}, [downloadECReceiptCSV, rows]);

	return (
		<div className="flex items-center">
			<div className="grid grid-cols-1 items-center gap-4 tablet:flex">
				{/* 検索件数 */}
				<p>件数：{searchResultCountText}件</p>

				{/* 売り上げ合計 */}
				<p>売り上げ合計：{totalSalesAmountText}円</p>

				<Button type="button" variant={"outline"} size="sm" onClick={handleClickDownloadCSVButton}>
					CSVダウンロード
				</Button>
			</div>
		</div>
	);
};

AboutForSearchResultTable.displayName = "AboutForSearchResultTable";
